import calls from '@/backend/api-calls'


const state = () => ({
  slabs: [],
  selected: [],
  allSelected: false,
  loading: false,
  firstLoad: true,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null
  }
})


const getters = {
  ids: state => {
    return state.slabs.map(d => d.id);
  }
}


const actions = {
  getSlabs: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.productionSheetsItems.get(parameters)
        .then(resp => {
          commit("setSlabs", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  updateSlab: ({commit}, { slabId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productionSheetsItem.put(slabId, data).then(
        resp => {
          commit("insertUpdatedSlab", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Slab successfully updated'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}


const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setSlabs(state, data) {
    state.pagination = data.pagination;
    state.slabs = data.results;
  },
  insertUpdatedSlab(state, data) {
    state.slabs.forEach((slab, i) => {
      if (slab.id == data.id) {
        state.slabs.splice(i, 1, data);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  selectAll(state, productionSheetIds) {
    state.allSelected = true;
    productionSheetIds.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}